import { iDoxApis } from 'Api/index';
//import { store } from 'Store/store.index';
export default class IDoxService {
  initialize(){
    iDoxApis.initialize()
  }
  checkDocumentType({content}){
    return iDoxApis.checkDocumentType({content})
  }
}